import React, { useCallback, useEffect, useRef } from 'react';
export function ImageCarousel() {
  const images = ['https://cdn.magicpatterns.com/uploads/guRQAtbjb1xsP9V9B2AVt5/3_001.png', 'https://cdn.magicpatterns.com/uploads/2rA7wGL6SWBBGaYZGnunJU/4_001.png', 'https://cdn.magicpatterns.com/uploads/oyswH6VeiucanJf2EJuHkU/5_001.png', 'https://cdn.magicpatterns.com/uploads/8Xu5mT3UbQCXZuvGjx67wV/cuentos_1_001.png', 'https://cdn.magicpatterns.com/uploads/n7x76ZF3bFVrFLMmzNq57d/matema_1_001.png'];
  const trackRef = useRef<HTMLDivElement>(null);
  const positionRef = useRef(0);
  const isDraggingRef = useRef(false);
  const dragStartXRef = useRef(0);
  const dragStartPosRef = useRef(0);
  const animFrameRef = useRef<number>(0);
  const lastTimeRef = useRef<number>(0);
  const speedRef = useRef(0.8); // pixels per frame at 60fps
  const getHalfWidth = useCallback(() => {
    if (!trackRef.current) return 1;
    return trackRef.current.scrollWidth / 2;
  }, []);
  const wrapPosition = useCallback((pos: number) => {
    const half = getHalfWidth();
    let wrapped = pos % half;
    if (wrapped > 0) wrapped -= half;
    return wrapped;
  }, [getHalfWidth]);
  const animate = useCallback((timestamp: number) => {
    if (!lastTimeRef.current) lastTimeRef.current = timestamp;
    const delta = timestamp - lastTimeRef.current;
    lastTimeRef.current = timestamp;
    if (!isDraggingRef.current) {
      // Auto-scroll: move left continuously (~48px per second)
      positionRef.current -= speedRef.current * (delta / 16.67);
      positionRef.current = wrapPosition(positionRef.current);
    }
    if (trackRef.current) {
      trackRef.current.style.transform = `translateX(${positionRef.current}px)`;
    }
    animFrameRef.current = requestAnimationFrame(animate);
  }, [wrapPosition]);
  useEffect(() => {
    animFrameRef.current = requestAnimationFrame(animate);
    return () => {
      if (animFrameRef.current) cancelAnimationFrame(animFrameRef.current);
    };
  }, [animate]);
  // Mouse events
  const handleMouseDown = (e: React.MouseEvent) => {
    isDraggingRef.current = true;
    dragStartXRef.current = e.clientX;
    dragStartPosRef.current = positionRef.current;
    e.preventDefault();
  };
  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDraggingRef.current) return;
    const diff = e.clientX - dragStartXRef.current;
    positionRef.current = wrapPosition(dragStartPosRef.current + diff);
  };
  const handleMouseUp = () => {
    isDraggingRef.current = false;
  };
  const handleMouseLeave = () => {
    isDraggingRef.current = false;
  };
  // Touch events
  const handleTouchStart = (e: React.TouchEvent) => {
    isDraggingRef.current = true;
    dragStartXRef.current = e.touches[0].clientX;
    dragStartPosRef.current = positionRef.current;
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    if (!isDraggingRef.current) return;
    const diff = e.touches[0].clientX - dragStartXRef.current;
    positionRef.current = wrapPosition(dragStartPosRef.current + diff);
  };
  const handleTouchEnd = () => {
    isDraggingRef.current = false;
  };
  return <section className="w-full bg-rose-50 py-8 overflow-hidden border-y border-pink-100" data-id="element-115">
      <div className="max-w-6xl mx-auto px-4 mb-6 text-center" data-id="element-116">
        <h2 className="text-3xl md:text-4xl font-black text-[#881337] mb-4" data-id="element-117">
          Mira lo que encontrarás dentro
        </h2>
        <p className="text-lg text-rose-800 font-medium" data-id="element-118">
          Un vistazo a las páginas de nuestro kit educativo
        </p>
      </div>

      <div className="relative w-full overflow-hidden select-none" style={{
      cursor: isDraggingRef.current ? 'grabbing' : 'grab'
    }} onMouseDown={handleMouseDown} onMouseMove={handleMouseMove} onMouseUp={handleMouseUp} onMouseLeave={handleMouseLeave} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} data-id="element-119">
        <div ref={trackRef} className="flex w-max will-change-transform" style={{
        transform: 'translateX(0px)'
      }} data-id="element-120">
          {/* First set */}
          {images.map((src, idx) => <div key={`img-1-${idx}`} className="w-[260px] md:w-[320px] flex-shrink-0 mx-4" data-id="element-121">
              <img src={src} alt={`Página de muestra ${idx + 1}`} className="w-full h-auto rounded-2xl shadow-xl border border-pink-100 object-cover pointer-events-none" draggable={false} data-id="element-122" />
            </div>)}
          {/* Second set for seamless loop */}
          {images.map((src, idx) => <div key={`img-2-${idx}`} className="w-[260px] md:w-[320px] flex-shrink-0 mx-4" data-id="element-123">
              <img src={src} alt={`Página de muestra ${idx + 1}`} className="w-full h-auto rounded-2xl shadow-xl border border-pink-100 object-cover pointer-events-none" draggable={false} data-id="element-124" />
            </div>)}
        </div>
      </div>
    </section>;
}